export const translate = (
  translations: { [key: string]: string },
  translation: string
): string | undefined => {
  return translations[translation]
}
